/**
 * @generated SignedSource<<3cf52cb7790510c2b25724c767781ae2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type getUserWorkspaceAccessSummaryQuery$variables = {
  shouldSkip: boolean;
  workspaceAri: string;
};
export type getUserWorkspaceAccessSummaryQuery$data = {
  readonly trello: {
    readonly userWorkspaceAccessSummary?: {
      readonly displayBoardCount: number | null | undefined;
      readonly displayName: string | null | undefined;
      readonly id: string;
    } | null | undefined;
  };
};
export type getUserWorkspaceAccessSummaryQuery = {
  response: getUserWorkspaceAccessSummaryQuery$data;
  variables: getUserWorkspaceAccessSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkip"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TrelloQueryApi",
    "kind": "LinkedField",
    "name": "trello",
    "plural": false,
    "selections": [
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "workspaceId",
                "variableName": "workspaceAri"
              }
            ],
            "concreteType": "TrelloWorkspaceAccessSummary",
            "kind": "LinkedField",
            "name": "userWorkspaceAccessSummary",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayBoardCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "getUserWorkspaceAccessSummaryQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "getUserWorkspaceAccessSummaryQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2b93b07ab2b199c8f36cbe23fff94dde",
    "id": null,
    "metadata": {},
    "name": "getUserWorkspaceAccessSummaryQuery",
    "operationKind": "query",
    "text": "query getUserWorkspaceAccessSummaryQuery(\n  $workspaceAri: ID!\n  $shouldSkip: Boolean!\n) {\n  trello {\n    userWorkspaceAccessSummary(workspaceId: $workspaceAri) @skip(if: $shouldSkip) @optIn(to: \"TrelloUserWorkspaceAccessSummary\") {\n      id\n      displayName\n      displayBoardCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dc4854fd11cd66cc3c744bc254b29e7";

export default node;
